import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { StyleSheetManager } from 'styled-components';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './Store/Store';
import { NavigationProvider } from './PHPComponents/NavigationContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
const shouldForwardProp = (prop, defaultValidatorFn) => !prop.startsWith('$');
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <NavigationProvider>
      <Router>
        <StyleSheetManager shouldForwardProp={shouldForwardProp}>
          <App />
        </StyleSheetManager>
      </Router>
    </NavigationProvider>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
